@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.login

import com.narbase.letsgo.router.EndPoint


object RequestVerificationCodeEndpoint : EndPoint<RequestVerificationCodeEndpoint.Request, RequestVerificationCodeEndpoint.Response>() {
    class Request (
        val phone: String,
        val isAndroid: Boolean
    )

    class Response
}

